import { useMutation } from "react-query"
import api from "../client"
import { AddressDetailResponseData, CreateAddressPayload } from "../types/address"

const postData = async (payload: CreateAddressPayload) => {
    const { data } = await api.post<AddressDetailResponseData>(
        `/address`,
        payload
    )
    return data
}

export const useCreateAddress = () => {
    return useMutation((payload: CreateAddressPayload) => {
        return postData(payload)
    })
}
